import { render, staticRenderFns } from "./importSpecificationCoding.vue?vue&type=template&id=e4e540f6&scoped=true"
import script from "./importSpecificationCoding.vue?vue&type=script&lang=ts"
export * from "./importSpecificationCoding.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e540f6",
  null
  
)

export default component.exports